module.exports = __webpack_public_path__ + "static/media/ambassador-inner-circle.dc965936.jpg";